<div class="fade modal modal-static pg-show-modal" [id]="'modal-' + id" tabindex="-1" role="dialog" aria-hidden="true"
    data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Selecciona el área de la imagen </h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
                    title="Cerrar modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12 text-center">
                        <image-cropper [transform]="transform" [resizeToWidth]="resizeToWidth" 
                            [alignImage]="'center'" 
                            [resizeToHeight]="resizeToHeight"
                            [cropperMinWidth]="cropperMinWidth"
                            [cropperMinHeight]="cropperMinHeight"
                            [backgroundColor]="'white'"
                            [aspectRatio]="resizeToWidth / resizeToHeight"
                            [maintainAspectRatio]="maintainAspectRatio" 
                            format="jpg"
                            [imageChangedEvent]="imageChangedEvent" (imageCropped)="imageCropped($event)"
                            (imageLoaded)="imageLoaded($event)" (cropperReady)="cropperReady()"
                            (loadImageFailed)="loadImageFailed($event)"></image-cropper>
                    </div>
                </div>
                <div class="row" *ngIf="">
                    <div class="col-12 text-center space-items-15">

                        <button class="btn btn-link btn-sm" type="button" data-toggle="modal"
                            data-target="#modal-employee-education" (click)="zoomIn()">
                            ZOOM +
                        </button>
                        <button class="btn btn-link btn-sm" type="button" data-toggle="modal"
                            data-target="#modal-employee-education" (click)="zoomOut()">
                            ZOOM -
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center space-items-15">
                        <button class="btn btn-link" data-dismiss="modal" type="button">Cancelar</button>
                        <button class="btn btn-outline-primary" data-dismiss="modal" type="button"
                            (click)="onClickAnotherFile($event)">Seleccionar otra
                            foto</button>
                        <button class="btn btn-primary" data-dismiss="modal" type="button"
                            (click)="onClickUpload($event)">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>